var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 39.2507C24.1039 39.2507 23.2079 38.9085 22.5247 38.2257L1.0258 16.7266C-0.341811 15.359 -0.341811 13.1416 1.0258 11.7746C2.39285 10.4075 4.60976 10.4075 5.97747 11.7746L25 30.7981L44.0225 11.7752C45.3902 10.4082 47.6068 10.4082 48.9738 11.7752C50.3421 13.1423 50.3421 15.3596 48.9738 16.7272L27.4752 38.2263C26.7917 38.9093 25.8957 39.2507 25 39.2507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.10433f1d6556c1c37bc20d83d39cd46c.svg";
export { ForwardRef as ReactComponent };